export default __webpack_public_path__ + "static/media/blue-folder.ab2a8041.svg";